// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {
	LOGOUT_USER,

	// Housekeeping Management
	HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE,
	HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE_SUCCESS,
	HOUSEKEEPING_MANAGEMENT_CREATE_HOUSEKEEPING,
	HOUSEKEEPING_MANAGEMENT_UPDATE_HOUSEKEEPING,
	HOUSEKEEPING_MANAGEMENT_DELETE_HOUSEKEEPING,

	// HOUSEKEEPING_MANAGEMENT_LOAD_POSITION,
	// HOUSEKEEPING_MANAGEMENT_LOAD_POSITION_SUCCESS,
	// HOUSEKEEPING_MANAGEMENT_CREATE_POSITION,
	// HOUSEKEEPING_MANAGEMENT_UPDATE_POSITION,
	// HOUSEKEEPING_MANAGEMENT_DELETE_POSITION,

	// HOUSEKEEPING_MANAGEMENT_LOAD_STAFF,
	// HOUSEKEEPING_MANAGEMENT_LOAD_STAFF_SUCCESS,
	// HOUSEKEEPING_MANAGEMENT_CREATE_STAFF,
	// HOUSEKEEPING_MANAGEMENT_UPDATE_STAFF,
	// HOUSEKEEPING_MANAGEMENT_DELETE_STAFF,
	// END Housekeeping Management


} from '../actions';

const INIT_STATE = {

	housekeeping: [],
	optionHousekeeping: [],

	// position: [],
	// optionPosition: [],

	// staff: [],
	// optionStaff: [],

	housekeepingLoading: false,
	// positionLoading: false,
	// staffLoading: false,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE:
			return { ...state, housekeepingLoading: true }
		case HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE_SUCCESS:
			return {
				...state,
				housekeepingLoading: false,
				housekeeping: action.payload,
				optionHousekeeping: action.payloadlist
			}
		case HOUSEKEEPING_MANAGEMENT_CREATE_HOUSEKEEPING:
			return { ...state, housekeepingLoading: true }
		case HOUSEKEEPING_MANAGEMENT_UPDATE_HOUSEKEEPING:
			return { ...state, housekeepingLoading: true }
		case HOUSEKEEPING_MANAGEMENT_DELETE_HOUSEKEEPING:
			return { ...state, housekeepingLoading: true }

		// case HOUSEKEEPING_MANAGEMENT_LOAD_POSITION:
		// 	return { ...state, positionLoading: true }
		// case HOUSEKEEPING_MANAGEMENT_LOAD_POSITION_SUCCESS:
		// 	return {
		// 		...state,
		// 		positionLoading: false,
		// 		position: action.payload,
		// 		optionPosition: action.payloadlist
		// 	}
		// case HOUSEKEEPING_MANAGEMENT_CREATE_POSITION:
		// 	return { ...state, positionLoading: true }
		// case HOUSEKEEPING_MANAGEMENT_UPDATE_POSITION:
		// 	return { ...state, positionLoading: true }
		// case HOUSEKEEPING_MANAGEMENT_DELETE_POSITION:
		// 	return { ...state, positionLoading: true }

		// case HOUSEKEEPING_MANAGEMENT_LOAD_STAFF:
		// 	return { ...state, staffLoading: true }
		// case HOUSEKEEPING_MANAGEMENT_LOAD_STAFF_SUCCESS:
		// 	return {
		// 		...state,
		// 		staffLoading: false,
		// 		staff: action.payload,
		// 		optionStaff: action.payloadlist
		// 	}
		// case HOUSEKEEPING_MANAGEMENT_CREATE_STAFF:
		// 	return { ...state, staffLoading: true }
		// case HOUSEKEEPING_MANAGEMENT_UPDATE_STAFF:
		// 	return { ...state, staffLoading: true }
		// case HOUSEKEEPING_MANAGEMENT_DELETE_STAFF:
		// 	return { ...state, staffLoading: true }

		case LOGOUT_USER:
			return {
				...state,
				housekeeping: [],
				optionHousekeeping: [],

				// position: [],
				// optionPosition: [],

				// staff: [],
				// optionStaff: [],

				housekeepingLoading: false,
				// positionLoading: false,
				// staffLoading: false,
			};

		default: return { ...state };
	}
}